var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOpenAnswerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.212,
    height: 10.801,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5300f2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1281",
    d: "M10.801 4.889v1.023H0V4.889z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1284",
    d: "M11.483 7.618v1.023H7.504V7.618z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1285",
    d: "M14.212 9.665v1.023H7.504V9.665z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1282",
    d: "M4.889 0h1.023v10.801H4.889z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOpenAnswerIcon);
export default __webpack_public_path__ + "static/media/add-open-answer-icon.aae448e76c7de3cc2039717cb173100c.svg";
export { ForwardRef as ReactComponent };